import React from 'react'
import { motion, useAnimation } from "framer-motion";
import { useInView } from "react-intersection-observer";
import { useEffect, useRef, useState } from 'react';
function useOnScreen(ref, rootMargin = '0px') {
    const [isIntersecting, setIntersecting] = useState(false);

    useEffect(() => {
        const observer = new IntersectionObserver(
            ([entry]) => {
                setIntersecting(entry.isIntersecting);
            },
            {
                rootMargin
            }
        );
        if (ref.current) {
            observer.observe(ref.current);
        }
        return () => {
            observer.unobserve(ref.current);
        };
    }, []);

    return isIntersecting;
}
export const SlideRight = ({ children }) => {
    const controls = useAnimation();
    const rootRef = useRef();
    const onScreen = useOnScreen(rootRef);
    useEffect(() => {
        if (onScreen) {
            controls.start({
                x: 0,
                opacity: 1,
                y:"50%",
                transition: {
                    duration: 0.85,
                    ease: "easeOut"
                },
                animationDelay:2000
            });
        }
    }, [onScreen, controls]);
    return (
        <motion.div
            className="lazy-div"
            ref={rootRef}
            initial={{ opacity: 0, x: -50 , y:"50%"}}
            animate={controls}
        >
            {children}
        </motion.div>
    );
};
export const LazyShow2 = ({ children }) => {
    const controls = useAnimation();
    const rootRef = useRef();
    const onScreen = useOnScreen(rootRef);
    useEffect(() => {
        if (onScreen) {
            controls.start({
                x: 0,
                opacity: 1,
                y:0,
                transition: {
                    duration: 1,
                    ease: "easeIn"
                },
                animationDelay:2000
            });
        }
    }, [onScreen, controls]);
    return (
        <motion.div
            className="lazy-div2"
            ref={rootRef}
            initial={{ opacity: 0, x: 0 , y:-100}}
            animate={controls}
        >
            {children}
        </motion.div>
    );
};
export const LazyShow3 = ({ children }) => {
    const controls = useAnimation();
    const rootRef = useRef();
    const onScreen = useOnScreen(rootRef);
    useEffect(() => {
        if (onScreen) {
            controls.start({
                x: 0,
                opacity: 1,
                y:0,
                transition: {
                    duration: 1,
                    ease: "easeIn"
                },
                animationDelay:200,
                scale:1
            });
        }
    }, [onScreen, controls]);
    return (
        <motion.div
            className="lazy-div3"
            ref={rootRef}
            initial={{ opacity: 0,scale:0, x: 0 , y:100}}
            animate={controls}
        >
            {children}
        </motion.div>
    );
};
export const SlideLeft = ({ children }) => {
    const controls = useAnimation();
    const rootRef = useRef();
    const onScreen = useOnScreen(rootRef);
    useEffect(() => {
        if (onScreen) {
            controls.start({
                x: 0,
                opacity: 1,
                y:0,
                transition: {
                    duration: 1,
                    ease: "easeIn"
                },
                animationDelay:2000,
                scale:1
            });
        }
    }, [onScreen, controls]);
    return (
        <motion.div
            className="slide-left"
            ref={rootRef}
            initial={{ opacity: 0, x: "-50%" , y:0}}
            animate={controls}
        >
            {children}
        </motion.div>
    );
};
